import { useEffect, useState } from 'react'

export const useTextWidth = (ref, maxWidth = 175) => {
  const [isMultiline, setIsMultiline] = useState(false)

  useEffect(() => {
    if (!ref.current || !ref.current.innerText) return

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const computedStyles = window.getComputedStyle(ref.current)
    context.font = computedStyles.font

    const { width: textWidth } = context.measureText(ref.current.innerText)

    setIsMultiline(textWidth > maxWidth)
  }, [ref, maxWidth])

  return isMultiline
}
